module.exports = __webpack_public_path__ + "static/harvey-norman-c48399f6fb4609875e59308eea294d50.jpg";